// extracted by mini-css-extract-plugin
module.exports = {"root":"fncIconButton_root__2bLBx","text":"fncIconButton_text__1rlKp","icon":"fncIconButton_icon__1V0n3"};